import { render, staticRenderFns } from "./TrustpilotRating.vue?vue&type=template&id=0466363c&scoped=true&"
import script from "./TrustpilotRating.vue?vue&type=script&lang=js&"
export * from "./TrustpilotRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466363c",
  null
  
)

export default component.exports